import moment from 'moment';
import 'moment/locale/es';
moment.locale('es');

export const compareDatesWithStringFormat = (a, b) => {
  // Normalize "p. m." -> "pm"
  const na = a
    ?.toLowerCase()
    .replace(/\./g, '')
    .replace('p m', 'pm')
    .replace('a m', 'am');
  const nb = b
    ?.toLowerCase()
    .replace(/\./g, '')
    .replace('p m', 'pm')
    .replace('a m', 'am');

  const fa = moment(na, 'DD/MM/YYYY hh:mm:ss a');
  const fb = moment(nb, 'DD/MM/YYYY hh:mm:ss a');

  // si no trae hora o falla, intenta solo fecha
  const ma = fa.isValid() ? fa : moment(na, 'DD/MM/YYYY');
  const mb = fb.isValid() ? fb : moment(nb, 'DD/MM/YYYY');

  return ma.valueOf() - mb.valueOf();
};

export function getDaysFromNow(dateStr) {
  if (!dateStr) return null;

  const normalized = dateStr
    ?.toLowerCase()
    .replace(/\./g, '')
    .replace('p m', 'pm')
    .replace('a m', 'am');

  const parsed = moment(
    normalized,
    ['DD/MM/YYYY hh:mm:ss a', 'DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY'],
    true
  );

  if (!parsed.isValid()) {
    return null;
  }

  return moment().diff(parsed, 'days');
}

export function isOlderThanDays(dateStr, threshold) {
  const diff = getDaysFromNow(dateStr);
  if (diff == null) return false;
  return diff >= threshold;
}

/* 
  1200000 -> '20 min'
  3900000 -> '1 h 05 min'
  7200000 -> '2 h'
*/
export const formatDuration = (ms) => {
  const minutes = Math.round(ms / 60000);
  if (minutes < 1) return 'menos de 1 min';

  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (!hours) return `${rest} min`;

  return rest
    ? `${hours} h ${String(rest).padStart(2, '0')} min`
    : `${hours} h`;
};
